<template lang="pug">
div
  transition(name='fade', enter-active-class='animated bounceInLeft', leave-active-class='animated bounceOutLeft')
    md-layout(md-flex='100', v-show='showVastTagAlert')
      md-whiteframe.validation-error-message(md-elevation='2')
        md-icon(md-iconset="fa fa-exclamation-triangle")
        span
          | It is not recommended to use insecure http:// URL for ad tags, as this may cause your ad to not render in some environments.
          | Please use an https:// URL for your ad tag to ensure correct ad functionality.

  // VAST Desktop
  md-layout(md-flex='100')
    md-layout
      md-input-container(:class='{ "md-input-invalid" : formSubmitted && validations.default.$invalid }')
        label VAST Tag
        md-input(v-model='ads.default')
        span.md-error(v-if='formSubmitted && validations.default.$invalid') Invalid URL
        md-layout(md-flex='5')
          md-icon.md-primary.info-tooltip(md-iconset="fa fa-info-circle")
            md-tooltip(md-direction='top') Enter a VAST Tag directly

  // Failover for Desktop
  md-layout(md-flex='100', v-if='isDefaultVastComplete')
    md-chips.failover(v-model='ads.default_failover', :md-max='4', md-input-placeholder='VAST TAG Failovers (up to 4)')
      template(slot-scope='chip')
        span {{ chip.value }}

  // VAST Mobile
  md-layout(md-flex='100')
    transition(name='fade', enter-active-class='animated bounceInLeft', leave-active-class='animated bounceOutLeft')
      md-layout
        md-input-container(v-show='isDefaultVastComplete && isMobilePlatformEnabled', :class='{ "md-input-invalid" : formSubmitted && validations.mobile.$invalid }')
          label VAST Tag for Mobile
          md-input(v-model='ads.mobile')
          span.md-error(v-if='formSubmitted && validations.mobile.$invalid') Invalid URL
          md-layout(md-flex='5')
            md-icon.md-primary.info-tooltip(md-iconset="fa fa-info-circle")
              md-tooltip(md-direction='top') Optionally, provide an alternative VAST Tag for Mobile platforms

  // Failover for Desktop
  md-layout(md-flex='100', v-if='isMobilePlatformEnabled && isMobileVastComplete')
    md-chips.failover(v-model='ads.mobile_failover', :md-max='4', md-input-placeholder='VAST TAG for Mobile Failovers (up to 4)')
      template(slot-scope='chip')
        span {{ chip.value }}
</template>

<script>
  import { isValidUrl } from '../services/validatorService';

  export default {
    props: {
      ads: {
        type: Object,
        required: true
      },
      platforms: {
        type: Object,
        required: true
      },
      validations: {
        type: Object,
        required: true
      },
      formSubmitted: {
        type: Boolean,
        default: false
      }
    },
    components: {
    },
    computed: {
      showVastTagAlert() {
        let def = isValidUrl(this.ads.default) && !this.ads.default.startsWith('https');
        let mob = this.ads.mobile && this.ads.mobile.length && isValidUrl(this.ads.mobile) && !this.ads.mobile.startsWith('https');
        return def || mob;
      },
      isDefaultVastComplete() {
        return this.ads.default.length && !this.validations.default.$invalid;
      },
      isMobileVastComplete() {
        return this.ads.mobile.length && !this.validations.mobile.$invalid;
      },
      isMobilePlatformEnabled() {
        return this.platforms.mobile_web || this.platforms.mobile_app;
      }
    },
    methods: {
    },
    mounted() {
      console.log(this.ads);
    },
    watch: {
    }
  };
</script>

<style lang="scss" scoped>
  .failover .md-chip {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;
    color: red;
  }
  .validation-error-message {
    width: 100%;
    margin: 10px 0;
    padding: 15px;
    background-color: #ff5722;
    color: #EBFAFF;
    font-size: 1.1em;
    .md-icon {
      margin-top: -2px;
      margin-right: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/Vast.vue